import { render, staticRenderFns } from "./aliyLayer.vue?vue&type=template&id=cbe1769e&"
import script from "./aliyLayer.vue?vue&type=script&lang=js&"
export * from "./aliyLayer.vue?vue&type=script&lang=js&"
import style0 from "./aliyLayer.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports